// extracted by mini-css-extract-plugin
export default {"Button":"PaymentContainerCloseButton_Button__pXyQZ"};